/* eslint-disable jsx-a11y/anchor-is-valid */
import clsx from 'clsx'
import React from 'react'
import { Link } from 'react-router-dom'
import { limitLength } from '../../../../reusable'
import { KTIcon } from '../../../helpers'
import { Tr } from '../../../i18n/Tr'

type Props = {
  className: string
  color: string
  tourpackageId: string
  tourPackageName: string
  image: string
  description: string
  progress: string
  deleteTourPackage?: any
  businessInfostatus?: string
  businessRejectReason?: string
}

const MixedWidget21: React.FC<Props> = ({ className, color, tourpackageId, tourPackageName, image, description, progress, deleteTourPackage, businessInfostatus, businessRejectReason }) => {
  const t = Tr()
  return (
    <div className={`card ${className}`}>
      {/* begin::Body */}
      <div className='card-body'>
        {/* begin::Heading */}
        <div className='d-flex flex-stack'>
          {/* begin:Info */}
          <div className='d-flex align-items-center'>
            {/* begin:Image */}
            <div className='symbol symbol-60px me-5'>
              <span className={clsx(`symbol-label`, `bg-${color}-light`)}>
                <img src={image} className='h-55px w-100 rounded align-self-center' alt='' />
              </span>
            </div>
            {/* end:Image */}

            {/* begin:Title */}
            <div className='d-flex flex-column flex-grow-1 my-lg-0 my-2 pr-3'>
              <Link to='../tourpackageoverview/' state={{ tourpackageId: tourpackageId }} className='text-dark fw-bold text-hover-primary fs-5'>
                {limitLength(tourPackageName, 22)}
              </Link>
            </div>
            {/* end:Title */}
          </div>
          {/* begin:Info */}

          {/* begin:Menu */}
          <div className='ms-1'>
            <Link
              to={'../addtourpackagebasicinfo/'}
              state={{ tourpackageId: tourpackageId }}
              onClick={() => sessionStorage.removeItem('indexTab')}
              className='btn btn-sm btn-icon btn-color-primary btn-active-light-primary'
              data-kt-menu-trigger='click'
              data-kt-menu-placement='bottom-end'
              data-kt-menu-flip='top-end'
            >
              <KTIcon iconName='notepad-edit' className='fs-2' />
            </Link>
            <button
              onClick={() => deleteTourPackage(tourpackageId)}
              className='btn btn-sm btn-icon btn-color-primary btn-active-light-primary'
              data-kt-menu-trigger='click'
              data-kt-menu-placement='bottom-end'
              data-kt-menu-flip='top-end'
            >
              <KTIcon iconName='trash-square' className='fs-2' />
            </button>
          </div>
          {/* end::Menu */}
        </div>
        {/* end::Heading */}

        {/* begin:Stats */}
        <div className='d-flex flex-column w-100 mt-12'>
          <div className='text-dark me-2 fw-bold pb-0'>{t('Verification Status')}</div>
          {
            businessInfostatus == '0' && (
              <span className='badge badge-light-warning me-auto mb-2'>{t('Pending')}</span>
            )
          }
          {
            businessInfostatus == '1' && (
              <span className='badge badge-light-success me-auto mb-2'>{t('Approved')}</span>
            )
          }
          {
            businessInfostatus == '2' && (
              <>
                <span className='badge badge-light-danger me-auto mb-2'>{t('Rejected')}</span>
                <div className="dropzone border-danger bg-light-danger mb-2" id="kt_ecommerce_add_reject_reason">
                  <div className="dz-message needsclick">
                    {/* <!--begin::Icon--> */}
                    <i className="fas fa-info-circle text-danger fs-5 mt-1"></i>
                    <div className="ms-4">
                      <span className="fs-7 fw-semibold text-gray-600">{businessRejectReason}</span>
                    </div>
                  </div>
                </div>
              </>
            )
          }
          {/* <span className='text-dark me-2 fw-bold pb-3'>Progress</span> */}

          <div className='progress h-5px w-100'>
            <div
              className={`progress-bar bg-${color}`}
              role='progressbar'
              style={{ width: progress }}
            ></div>
          </div>
        </div>
        {/* end:Stats */}

        {/* begin:Team */}
        <div className='d-flex flex-column mt-10'>
          <div className='text-dark me-2 fw-bold pb-1'>{t('Highlight')}</div>
          <span className='text-muted fw-semibold'><div dangerouslySetInnerHTML={{ __html: limitLength(description, 110) }}></div></span>
        </div>
        {/* end:Team */}
      </div>
      {/* end::Body */}
    </div>
  )
}

export { MixedWidget21 }
